module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/mary-gunnett-e67f1841443dca6cf95cff355eeeccb1.jpg";